module.exports = new __parcel__URL__("epa-waste--cover.1809bf0e.jpg").toString();